import { render, staticRenderFns } from "./temp.vue?vue&type=template&id=71b6c038&scoped=true&"
import script from "./temp.vue?vue&type=script&lang=js&"
export * from "./temp.vue?vue&type=script&lang=js&"
import style0 from "./temp.vue?vue&type=style&index=0&id=71b6c038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b6c038",
  null
  
)

export default component.exports